type IconProps = React.ComponentProps<'svg'>

export function AiChip2Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 17C15.5217 17 15.9493 16.6163 16.0217 16.0733C16.7391 11.2371 17.3986 10.5638 22.0507 10.0353C22.587 9.97014 23 9.52127 23 9C23 8.47149 22.5942 8.0371 22.058 7.95747C17.4348 7.31312 16.8623 6.74842 16.0217 1.91946C15.9275 1.38371 15.5145 1 15 1C14.471 1 14.0507 1.38371 13.9638 1.9267C13.2609 6.75566 12.6014 7.42896 7.95652 7.95747C7.4058 8.02986 7 8.46425 7 9C7 9.52127 7.3913 9.95566 7.94203 10.0353C12.5725 10.6941 13.1377 11.2516 13.9638 16.0805C14.0725 16.6235 14.4928 17 15 17Z"
        fill="currentColor"
      />
      <path
        d="M5 23C5.26087 23 5.47464 22.8081 5.51087 22.5367C5.86957 20.1186 6.19928 19.7819 8.52536 19.5176C8.79348 19.4851 9 19.2606 9 19C9 18.7357 8.7971 18.5186 8.52899 18.4787C6.21739 18.1566 5.93116 17.8742 5.51087 15.4597C5.46377 15.1919 5.25725 15 5 15C4.73551 15 4.52536 15.1919 4.48188 15.4633C4.13043 17.8778 3.80072 18.2145 1.47826 18.4787C1.2029 18.5149 1 18.7321 1 19C1 19.2606 1.19565 19.4778 1.47101 19.5176C3.78623 19.8471 4.06884 20.1258 4.48188 22.5403C4.53623 22.8118 4.74638 23 5 23Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function AiStudio2Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2223 17.5554C14.7295 17.5554 15.1452 17.1824 15.2156 16.6545C15.9131 11.9527 16.5542 11.2981 21.0771 10.7842C21.5984 10.7209 22 10.2845 22 9.77772C22 9.2639 21.6055 8.84158 21.0842 8.76415C16.5894 8.13771 16.0329 7.5887 15.2156 2.89391C15.1241 2.37305 14.7225 2 14.2223 2C13.708 2 13.2994 2.37305 13.2149 2.90095C12.5315 7.59573 11.8904 8.25033 7.37452 8.76415C6.8391 8.83454 6.44458 9.25686 6.44458 9.77772C6.44458 10.2845 6.82501 10.7068 7.36043 10.7842C11.8622 11.4248 12.4117 11.9667 13.2149 16.6615C13.3205 17.1894 13.7291 17.5554 14.2223 17.5554Z"
        fill="currentColor"
      />
      <path
        d="M6.44453 22.0001C6.73439 22.0001 6.9719 21.787 7.01216 21.4853C7.41071 18.7986 7.77705 18.4245 10.3616 18.1309C10.6595 18.0947 10.8889 17.8453 10.8889 17.5557C10.8889 17.2621 10.6635 17.0208 10.3656 16.9766C7.79718 16.6186 7.47915 16.3049 7.01216 13.6221C6.95983 13.3245 6.73036 13.1113 6.44453 13.1113C6.15065 13.1113 5.91716 13.3245 5.86885 13.6262C5.47836 16.3089 5.11201 16.6829 2.53152 16.9766C2.22556 17.0168 2.00012 17.2581 2.00012 17.5557C2.00012 17.8453 2.21751 18.0867 2.52347 18.1309C5.09591 18.4969 5.40992 18.8066 5.86885 21.4893C5.92924 21.791 6.16273 22.0001 6.44453 22.0001Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function AiStudioIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9998 14L9.99985 11M15.0102 3.5V2M18.9495 5.06066L20.0102 4M18.9495 13L20.0102 14.0607M11.0102 5.06066L9.94954 4M20.5102 9H22.0102M6.13122 20.8686L15.3685 11.6314C15.7645 11.2354 15.9625 11.0373 16.0367 10.809C16.1019 10.6082 16.1019 10.3918 16.0367 10.191C15.9625 9.96265 15.7645 9.76465 15.3685 9.36863L14.6312 8.63137C14.2352 8.23535 14.0372 8.03735 13.8089 7.96316C13.608 7.8979 13.3917 7.8979 13.1908 7.96316C12.9625 8.03735 12.7645 8.23535 12.3685 8.63137L3.13122 17.8686C2.7352 18.2646 2.53719 18.4627 2.46301 18.691C2.39775 18.8918 2.39775 19.1082 2.46301 19.309C2.53719 19.5373 2.7352 19.7354 3.13122 20.1314L3.86848 20.8686C4.2645 21.2646 4.4625 21.4627 4.69083 21.5368C4.89168 21.6021 5.10802 21.6021 5.30887 21.5368C5.53719 21.4627 5.7352 21.2646 6.13122 20.8686Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AiStudioMenuIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_786_98841)">
        <path d="M12 1L12 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 21L12 23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M21 12L23 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M1 12L3 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M7 1L7 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M7 21L7 23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M21 17L23 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M1 17L3 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M17 1L17 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M17 21L17 23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M21 7L23 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M1 7L3 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6ZM7.2 4C5.43269 4 4 5.43269 4 7.2V16.8C4 18.5673 5.43269 20 7.2 20H16.8C18.5673 20 20 18.5673 20 16.8V7.2C20 5.43269 18.5673 4 16.8 4H7.2Z"
          fill="currentColor"
        />
        <path
          d="M10.7105 10.0526C11.8296 10.0526 12.7368 9.14542 12.7368 8.02632C12.7368 6.90721 11.8296 6 10.7105 6C9.59142 6 8.6842 6.90721 8.6842 8.02632C8.6842 9.14542 9.59142 10.0526 10.7105 10.0526Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 13.8105V16C5 17.6569 6.34314 19 7.99999 19H16C16.4408 19 16.8595 18.9049 17.2366 18.7341L11.4474 12.8895L10.2684 11.7105C9.3842 10.8263 7.94736 10.8263 7.06315 11.7105L5 13.8105Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 16.0093C18.9979 16.7025 18.7607 17.3404 18.3639 17.8474L12.921 12.2632C12.7 12.0421 12.7 11.6369 12.921 11.4158L14.1 10.2369C14.9474 9.35268 16.3842 9.35268 17.2684 10.2369L19 11.9685V16.0093Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_786_98841">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function BackgroundsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1C2.34315 1 1 2.34315 1 4V15C1 16.6569 2.34315 18 4 18H6V20C6 21.6569 7.34315 23 9 23H20C21.6569 23 23 21.6569 23 20V9C23 7.34315 21.6569 6 20 6H18V4C18 2.34315 16.6569 1 15 1H4ZM16 7V4C16 3.44772 15.5523 3 15 3H4C3.44772 3 3 3.44772 3 4V13.2602L4.54783 11.6848C5.43478 10.7978 6.87609 10.7978 7.76304 11.6848L8.94565 12.8674L12.0446 16H14.1164L10.4239 12.2391C10.2022 12.0174 10.2022 11.6109 10.4239 11.3891L11.6065 10.2065C12.4565 9.31955 13.8978 9.31955 14.7848 10.2065L16 11.4217V7ZM8 18H15C16.6569 18 18 16.6569 18 15V8H20C20.5523 8 21 8.44772 21 9V20C21 20.5523 20.5523 21 20 21H9C8.44772 21 8 20.5523 8 20V18ZM10.0652 7.03261C10.0652 8.15519 9.15519 9.06522 8.03261 9.06522C6.91003 9.06522 6 8.15519 6 7.03261C6 5.91003 6.91003 5 8.03261 5C9.15519 5 10.0652 5.91003 10.0652 7.03261Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function BrandHubIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_817_98749)">
        <path
          d="M8.88539 2.29085L8.35519 2.06736C8.16399 1.98636 7.95774 1.94701 7.75014 1.95193C7.54255 1.95685 7.33839 2.00594 7.15125 2.09591C6.9641 2.18588 6.79827 2.31468 6.66478 2.47374C6.53129 2.6328 6.43321 2.81846 6.37707 3.01838L6.22015 3.57235C6.1335 3.8636 5.95826 4.12061 5.71879 4.30767C5.47932 4.49472 5.18753 4.60253 4.88397 4.61609L4.3086 4.64462C3.9337 4.66232 3.57996 4.8235 3.32061 5.0948C3.06126 5.3661 2.91616 5.72674 2.91536 6.10206C2.91529 6.18653 2.92245 6.27084 2.93675 6.35408L3.03423 6.91994C3.08663 7.22163 3.043 7.53216 2.90948 7.80773C2.77596 8.08329 2.5593 8.30999 2.29006 8.45584L1.77651 8.73877C1.59355 8.83733 1.43369 8.97375 1.30761 9.13896C1.18152 9.30416 1.0921 9.49434 1.04531 9.69682C0.99851 9.89931 0.995414 10.1094 1.03623 10.3132C1.07704 10.517 1.16082 10.7097 1.28198 10.8786L1.61721 11.3541C1.79601 11.6028 1.89219 11.9013 1.89219 12.2076C1.89219 12.5139 1.79601 12.8125 1.61721 13.0612L1.2796 13.5367C1.1577 13.7043 1.07283 13.896 1.03062 14.0989C0.988423 14.3018 0.989853 14.5114 1.03482 14.7138C1.07979 14.9161 1.16726 15.1066 1.29144 15.2726C1.41562 15.4386 1.57368 15.5762 1.75511 15.6765L2.25915 15.9523C2.52752 16.0993 2.74299 16.3268 2.87522 16.6028C3.00744 16.8788 3.04976 17.1892 2.99619 17.4905L2.89396 18.0564C2.87845 18.1419 2.87049 18.2286 2.87018 18.3155C2.87089 18.6897 3.015 19.0493 3.27285 19.3204C3.53069 19.5916 3.88265 19.7535 4.2563 19.773L4.83166 19.8039C5.13742 19.82 5.43039 19.9317 5.66927 20.1233C5.90815 20.3148 6.08087 20.5765 6.16309 20.8714L6.31763 21.4254C6.37388 21.6247 6.47183 21.8098 6.60499 21.9684C6.73816 22.127 6.9035 22.2556 7.09006 22.3455C7.27663 22.4354 7.48017 22.4846 7.68721 22.49C7.89424 22.4953 8.10005 22.4566 8.291 22.3764L8.82119 22.1553C9.10397 22.0369 9.41678 22.0104 9.71543 22.0796C10.0141 22.1487 10.2835 22.3099 10.4855 22.5405L10.8659 22.9732C11.0031 23.1286 11.1718 23.253 11.3607 23.3382C11.5497 23.4235 11.7546 23.4675 11.9619 23.4675C12.1692 23.4675 12.3742 23.4235 12.5631 23.3382C12.7521 23.253 12.9208 23.1286 13.058 22.9732L13.4408 22.5428C13.644 22.3139 13.9139 22.1545 14.2124 22.0871C14.511 22.0197 14.8232 22.0477 15.1051 22.1672L15.6353 22.3907C15.8265 22.4717 16.0327 22.511 16.2403 22.5061C16.4479 22.5012 16.6521 22.4521 16.8392 22.3621C17.0263 22.2721 17.1922 22.1433 17.3257 21.9843C17.4592 21.8252 17.5572 21.6396 17.6134 21.4396L17.7703 20.8857C17.8558 20.5912 18.0318 20.331 18.2733 20.142C18.5148 19.953 18.8096 19.8447 19.116 19.8324L19.6914 19.8063C19.8985 19.7969 20.1013 19.7434 20.2862 19.6495C20.4711 19.5556 20.6339 19.4234 20.7637 19.2616C20.8935 19.0999 20.9873 18.9123 21.039 18.7115C21.0906 18.5106 21.0989 18.3011 21.0632 18.0968L20.9657 17.531C20.9133 17.2293 20.957 16.9187 21.0905 16.6432C21.224 16.3676 21.4407 16.1409 21.7099 15.9951L22.2234 15.7097C22.4064 15.6112 22.5663 15.4748 22.6924 15.3096C22.8184 15.1444 22.9079 14.9542 22.9547 14.7517C23.0014 14.5492 23.0045 14.3391 22.9637 14.1353C22.9229 13.9315 22.8391 13.7388 22.718 13.57L22.3827 13.0944C22.2039 12.8457 22.1078 12.5472 22.1078 12.2409C22.1078 11.9346 22.2039 11.636 22.3827 11.3874L22.7204 10.9118C22.8423 10.7442 22.9271 10.5526 22.9693 10.3496C23.0115 10.1467 23.0101 9.93707 22.9651 9.73472C22.9202 9.53237 22.8327 9.3419 22.7085 9.17593C22.5843 9.00996 22.4263 8.87229 22.2448 8.77205L21.7408 8.49626C21.4724 8.34922 21.257 8.12169 21.1247 7.84573C20.9925 7.56976 20.9502 7.25927 21.0038 6.95798L21.106 6.39212C21.1215 6.3066 21.1294 6.21988 21.1298 6.13297C21.1291 5.75882 20.985 5.39918 20.7271 5.12807C20.4693 4.85696 20.1173 4.695 19.7437 4.67553L19.1564 4.66365C18.8507 4.64751 18.5577 4.5358 18.3188 4.34427C18.0799 4.15274 17.9072 3.89106 17.825 3.59613L17.6704 3.04216C17.6142 2.84284 17.5162 2.65774 17.3831 2.49912C17.2499 2.34051 17.0846 2.21199 16.898 2.12207C16.7114 2.03216 16.5079 1.98291 16.3009 1.97757C16.0938 1.97224 15.888 2.01095 15.6971 2.09114L15.1669 2.31225C14.8841 2.4306 14.5713 2.4571 14.2726 2.38798C13.974 2.31887 13.7046 2.15764 13.5026 1.92708L13.1222 1.49437C12.985 1.33898 12.8163 1.21454 12.6273 1.12931C12.4384 1.04408 12.2334 1 12.0261 1C11.8188 1 11.6139 1.04408 11.4249 1.12931C11.236 1.21454 11.0673 1.33898 10.9301 1.49437L10.5497 1.9152C10.3465 2.14413 10.0766 2.30353 9.778 2.37093C9.47942 2.43832 9.16721 2.41031 8.88539 2.29085ZM11.8431 9.32364L12.0024 9.48294L12.1593 9.32602C12.4247 9.06063 12.7397 8.85011 13.0865 8.70648C13.4332 8.56286 13.8049 8.48893 14.1802 8.48893C14.5555 8.48893 14.9272 8.56286 15.2739 8.70648C15.6207 8.85011 15.9357 9.06063 16.2011 9.32602C16.4665 9.59141 16.677 9.90648 16.8207 10.2532C16.9643 10.6 17.0382 10.9716 17.0382 11.3469C17.0382 11.7223 16.9643 12.0939 16.8207 12.4407C16.677 12.7874 16.4665 13.1025 16.2011 13.3679L12.3114 17.2456C12.271 17.2861 12.223 17.3182 12.1702 17.3401C12.1174 17.362 12.0607 17.3733 12.0035 17.3733C11.9464 17.3733 11.8897 17.362 11.8369 17.3401C11.7841 17.3182 11.7361 17.2861 11.6957 17.2456L7.80836 13.3583C7.27238 12.8224 6.97126 12.0954 6.97126 11.3374C6.97126 10.9621 7.04519 10.5905 7.18882 10.2437C7.33245 9.89697 7.54297 9.5819 7.80836 9.31651C8.07375 9.05112 8.38881 8.8406 8.73556 8.69697C9.08231 8.55335 9.45396 8.47942 9.82927 8.47942C10.5873 8.47942 11.3142 8.78053 11.8502 9.31651L11.8431 9.32364Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_817_98749">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function DrawMenuIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_817_98730)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3864 3.38776C10.8246 3.24038 11.2908 3.46084 11.4997 3.87319L14.118 9.04138C14.4303 9.65791 14.9447 10.1521 15.5776 10.4436L20.3701 12.6509C20.7489 12.8254 20.9865 13.2192 20.9145 13.63C19.5057 21.6734 4.24826 25.3652 0 18.103C4.41999 17.1398 4.82417 14.008 5.23054 10.8591C5.56134 8.2959 5.8936 5.72139 8.39463 4.29626C9.07816 3.90678 9.74205 3.60452 10.3864 3.38776Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5961 1.87662C16.3391 1.39133 15.7389 1.20404 15.2515 1.45706L13.8947 2.16148C13.4018 2.41742 13.2118 3.02607 13.4718 3.51695L15.9197 8.13995C16.029 8.34645 16.2091 8.51196 16.4306 8.6096L21.1356 10.6829C21.5579 10.869 22.0526 10.742 22.3331 10.3755L23.2272 9.2068C23.6208 8.69239 23.429 7.94523 22.8363 7.68404L19.7342 6.31706C19.0695 6.02417 18.5293 5.52763 18.2013 4.90814L16.5961 1.87662Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_817_98730">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ElementsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5556 3.62963H16.6852C16.6037 3.3037 16.5222 2.97778 16.4815 2.69259C16.4407 2.40741 16.1963 2.12222 15.9111 2.04074C15.6259 1.95926 15.3 2.04074 15.0963 2.24444C14.6481 2.69259 14.3222 3.18148 14.037 3.62963H10.3704C10.3296 3.62963 10.3296 3.62963 10.2889 3.62963L8.9037 2.24444C8.57778 1.91852 8.08889 1.91852 7.76296 2.24444L6.37778 3.62963H3.44444C2.1 3.62963 1 4.72963 1 6.07407V15.8519V17.4815C1 18.8259 2.1 19.9259 3.44444 19.9259H8.98519C8.78148 20.4963 8.33333 21.2296 7.27407 21.5963C6.94815 21.7185 6.7037 22.0037 6.7037 22.3296C6.7037 22.8185 7.07037 23.1852 7.51852 23.1852H16.4407C16.7667 23.1852 17.0519 23.0222 17.2148 22.7778C17.4185 22.3704 17.2556 21.8815 16.8481 21.6778C15.8296 21.1481 15.3 20.4963 15.0963 19.9667H20.5556C21.9 19.9667 23 18.8667 23 17.5222V6.07407C23 4.72963 21.9 3.62963 20.5556 3.62963ZM7.11111 5.17778L7.27407 5.01481L8.33333 3.95556L9.55556 5.17778V6.07407H7.11111V5.17778ZM2.62963 15.037V6.07407C2.62963 5.62593 2.9963 5.25926 3.44444 5.25926H5.48148V12.3481C5.48148 12.9185 5.97037 13.4074 6.54074 13.4074H10.1259C10.6963 13.4074 11.1852 12.9185 11.1852 12.3481V5.25926H13.3037C12.8148 7.05185 13.1407 8.76296 13.5889 9.78148C12.8556 11.7778 12.7741 13.8556 12.8148 15.037H2.62963ZM9.96296 21.5556C10.3296 21.0259 10.5741 20.4148 10.6963 19.9259H13.3852C13.5074 20.3741 13.7519 20.9444 14.2 21.5556H9.96296ZM16.8889 15.037H14.4444C14.4037 14.0185 14.4444 12.063 15.137 10.2704C15.2593 10.2296 15.4222 10.1481 15.6667 10.1481C15.9111 10.1481 16.0741 10.2296 16.1963 10.2704C16.8889 12.063 16.9296 14.0185 16.8889 15.037ZM21.3704 15.037H18.5185C18.5593 13.8963 18.4778 11.8593 17.7852 9.9037C18.8444 8.43704 18.4778 6.6037 17.4185 5.5037C17.3778 5.42222 17.2963 5.34074 17.2556 5.25926H20.5556C21.0037 5.25926 21.3704 5.62593 21.3704 6.07407V15.037Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function GraphicsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6V4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6V8C19 8.55228 18.5523 9 18 9H6C5.44772 9 5 8.55228 5 8V6ZM5.0633 11.6491C5.20542 11.2699 5.57119 11 6 11H18C18.5523 11 19 11.4477 19 12V18C19 18.5523 18.5523 19 18 19H12.4142L13.8536 20.4393C14.7985 21.3843 14.1293 23 12.7929 23H2.5C1.67157 23 1 22.3284 1 21.5V11.2071C1 9.87075 2.61571 9.2015 3.56066 10.1464L5.0633 11.6491ZM3 21V12.4142L11.5858 21H3Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function HelpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_918_120739)">
        <path
          d="M8.75 8.6V8C8.75 6.89543 9.64543 6 10.75 6H13.25C14.3546 6 15.25 6.89543 15.25 8V10.4843C15.25 11.3901 14.5157 12.1244 13.6098 12.1244V12.1244C12.704 12.1244 11.9696 12.8588 11.9696 13.7646V14.6667"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="12" cy="18" r="0.5" fill="currentColor" stroke="currentColor" />
        <path
          d="M1 6V3C1 1.89543 1.89543 1 3 1H6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M23 18L23 21C23 22.1046 22.1046 23 21 23L18 23"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M18 1L21 1C22.1046 1 23 1.89543 23 3L23 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M6 23L3 23C1.89543 23 1 22.1046 1 21L1 18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_918_120739">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function Help2Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_918_120777)">
        <path
          d="M17 6H21C22.1046 6 23 6.89543 23 8V17C23 18.1046 22.1046 19 21 19H19.1C19.0448 19 19 19.0448 19 19.1V22.7539C19 22.8436 18.8909 22.888 18.8283 22.8236L15.136 19.0303C15.1172 19.0109 15.0913 19 15.0643 19H8C6.89543 19 6 18.1046 6 17V12.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 0C1.34315 0 0 1.34315 0 3V12C0 13.6569 1.34315 15 3 15H4V17.7539C4 18.7411 5.1997 19.2285 5.88825 18.5211L9.31559 15H16C17.6569 15 19 13.6569 19 12V3C19 1.34315 17.6569 0 16 0H3ZM4 3C3.44772 3 3 3.44772 3 4C3 4.55228 3.44772 5 4 5H9C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3H4ZM3 7C3 6.44772 3.44772 6 4 6H13C13.5523 6 14 6.44772 14 7C14 7.55228 13.5523 8 13 8H4C3.44772 8 3 7.55228 3 7ZM4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11H9C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9H4Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_918_120777">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.93103C8.43452 5.93103 5.55176 8.81379 5.55176 12.3793C5.55176 14.9207 7.069 17.1965 9.34486 18.2586V19.2069C9.34486 20.6862 10.5207 21.8621 12 21.8621C13.4793 21.8621 14.6552 20.6862 14.6552 19.2069V18.2586C16.9311 17.2345 18.4483 14.9207 18.4483 12.3793C18.4483 8.81379 15.5656 5.93103 12 5.93103ZM14.8449 14.8828C14.1242 15.7172 13.1 16.1724 12 16.1724C11.5828 16.1724 11.2414 15.831 11.2414 15.4138C11.2414 14.9965 11.5828 14.6552 12 14.6552C12.6449 14.6552 13.2897 14.3897 13.7069 13.8965C13.9724 13.5931 14.4656 13.5552 14.769 13.8207C15.1104 14.0862 15.1104 14.5793 14.8449 14.8828ZM15.0345 13.1379C14.6173 13.1379 14.2759 12.7965 14.2759 12.3793C14.2759 12.0759 14.238 11.8103 14.1242 11.5448C13.9724 11.1655 14.1621 10.7103 14.5414 10.5586C14.9207 10.4069 15.3759 10.5965 15.5276 10.9759C15.7173 11.431 15.7931 11.9241 15.7931 12.4172C15.7931 12.7965 15.4518 13.1379 15.0345 13.1379Z"
        fill="currentColor"
      />
      <path
        d="M11.2413 1.75862V3.65517C11.2413 4.07241 11.5827 4.41379 11.9999 4.41379C12.4171 4.41379 12.7585 4.07241 12.7585 3.65517V1.75862C12.7585 1.34138 12.4171 1 11.9999 1C11.5827 1 11.2413 1.34138 11.2413 1.75862Z"
        fill="currentColor"
      />
      <path
        d="M3.65517 12.7587C4.07241 12.7587 4.41379 12.4173 4.41379 12.0001C4.41379 11.5828 4.07241 11.2415 3.65517 11.2415H1.75862C1.34138 11.2415 1 11.5828 1 12.0001C1 12.4173 1.34138 12.7587 1.75862 12.7587H3.65517Z"
        fill="currentColor"
      />
      <path
        d="M22.2414 11.2415H20.3448C19.9276 11.2415 19.5862 11.5828 19.5862 12.0001C19.5862 12.4173 19.9276 12.7587 20.3448 12.7587H22.2414C22.6586 12.7587 23 12.4173 23 12.0001C23 11.5828 22.6586 11.2415 22.2414 11.2415Z"
        fill="currentColor"
      />
      <path
        d="M5.28612 19.7759L6.6137 18.4483C6.91715 18.1449 6.91715 17.6897 6.6137 17.3863C6.31025 17.0828 5.85508 17.0828 5.55163 17.3863L4.22405 18.7139C3.9206 19.0173 3.9206 19.4725 4.22405 19.7759C4.37577 19.9277 4.56543 20.0035 4.75508 20.0035C4.94474 20.0035 5.13439 19.9277 5.28612 19.7759Z"
        fill="currentColor"
      />
      <path
        d="M19.7758 4.22417C19.4724 3.92072 19.0172 3.92072 18.7138 4.22417L17.3483 5.55175C17.0448 5.8552 17.0448 6.31037 17.3483 6.61382C17.5 6.76555 17.6896 6.84141 17.8793 6.84141C18.0689 6.84141 18.2586 6.76555 18.4103 6.61382L19.7379 5.28624C20.0793 4.98279 20.0793 4.52762 19.7758 4.22417Z"
        fill="currentColor"
      />
      <path
        d="M4.22405 4.22417C3.9206 4.52762 3.9206 4.98279 4.22405 5.28624L5.55163 6.61382C5.70336 6.76555 5.89301 6.84141 6.08267 6.84141C6.27232 6.84141 6.46198 6.76555 6.6137 6.61382C6.91715 6.31037 6.91715 5.8552 6.6137 5.55175L5.28612 4.22417C4.98267 3.92072 4.52749 3.92072 4.22405 4.22417Z"
        fill="currentColor"
      />
      <path
        d="M18.4482 17.3483C18.1448 17.0449 17.6896 17.0449 17.3862 17.3483C17.0827 17.6518 17.0827 18.1069 17.3862 18.4104L18.7137 19.738C18.8655 19.8897 19.0551 19.9656 19.2448 19.9656C19.4344 19.9656 19.6241 19.8897 19.7758 19.738C20.0793 19.4345 20.0793 18.9793 19.7758 18.6759L18.4482 17.3483Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PatternsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_817_98772)">
        <path
          d="M1 6V3C1 1.89543 1.89543 1 3 1H6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M23 18L23 21C23 22.1046 22.1046 23 21 23L18 23"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M18 1L21 1C22.1046 1 23 1.89543 23 3L23 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M6 23L3 23C1.89543 23 1 22.1046 1 21L1 18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M19 5V12.3684C19 16.0309 16.0309 19 12.3684 19H5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M19 5H14.15C10.4875 5 7.5184 7.96906 7.5184 11.6316V16.4816C7.5184 17.8725 6.39088 19 5 19V19"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M19 5V5C15.8575 5 13.31 7.5475 13.31 10.69V12C13.31 15.866 10.176 19 6.31001 19L5 19"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M18.565 13.3958L18.9194 7.37099C18.9683 6.53927 18.5168 5.75842 17.7716 5.38581L17.6672 5.33359C17.24 5.11999 16.7455 5.08485 16.2924 5.23588C15.7898 5.40339 15.3865 5.78366 15.1898 6.27548L14.7122 7.46949C14.5722 7.81951 14.3625 8.13745 14.096 8.40402C13.7074 8.79263 13.4425 9.28757 13.3347 9.82647L13.1232 10.8839C13.0413 11.2936 13 11.7105 13 12.1283V13.3559C13 13.7825 12.9312 14.2063 12.7963 14.6111C12.6014 15.1957 12.2732 15.7268 11.8374 16.1626L10.5749 17.4251C10.5251 17.4749 10.4803 17.5295 10.4413 17.5881C10.0048 18.2428 10.4009 19.1287 11.1798 19.24L12.5143 19.4306C12.833 19.4761 13.158 19.4408 13.4594 19.3277L14.4982 18.9382C16.0963 18.3389 17.3885 17.0935 18.0608 15.5247C18.3491 14.852 18.522 14.1264 18.565 13.3958Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_817_98772">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function PhotosIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 6V22H2V6H2.63768V17.7217L5.3971 14.913C6.57971 13.7304 8.50144 13.7304 9.68405 14.913L11.2609 16.4898L15.7942 21.0724H18.5536L13.2319 15.6521C12.9362 15.3565 12.9362 14.8145 13.2319 14.5188L14.8087 12.942C15.942 11.7594 17.8638 11.7594 19.0464 12.942L21.3623 15.2579V6H22Z"
        fill="currentColor"
      />
      <path
        d="M10.0435 10.4203C11.5403 10.4203 12.7537 9.20691 12.7537 7.71014C12.7537 6.21337 11.5403 5 10.0435 5C8.54675 5 7.33337 6.21337 7.33337 7.71014C7.33337 9.20691 8.54675 10.4203 10.0435 10.4203Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TemplatesIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="1"
        width="16"
        height="22"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="9.5" cy="4.5" r="1.5" fill="currentColor" />
      <path
        d="M4 12.9L7.79508 8.79441C8.19097 8.36614 8.86786 8.36614 9.26374 8.79441L15 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 10L14.9766 6.78595C15.3703 6.36091 16.0416 6.35826 16.4386 6.78018L20 10.5652"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 14C4 13.4477 4.44772 13 5 13H19C19.5523 13 20 13.4477 20 14V22C20 22.5523 19.5523 23 19 23H5C4.44772 23 4 22.5523 4 22V14ZM6 17C6 16.4477 6.44772 16 7 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H7C6.44772 18 6 17.5523 6 17ZM7 19C6.44772 19 6 19.4477 6 20C6 20.5523 6.44772 21 7 21H12C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19H7Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TextMenuIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_817_98731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 2C1 1.44772 1.44772 1 2 1H22C22.5523 1 23 1.44772 23 2V4V6C23 6.55228 22.5523 7 22 7H21C20.4477 7 20 6.55228 20 6V4H4V6C4 6.55228 3.55228 7 3 7H2C1.44772 7 1 6.55228 1 6V4V2ZM13.5 20H16C16.5523 20 17 20.4477 17 21V22C17 22.5523 16.5523 23 16 23H13.5H10.5H8C7.44772 23 7 22.5523 7 22V21C7 20.4477 7.44772 20 8 20H10.5L10.5 6.5C10.5 5.94772 10.9477 5.5 11.5 5.5H12.5C13.0523 5.5 13.5 5.94771 13.5 6.5L13.5 20Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_817_98731">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function UploadMenu2Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.9196 14.4102C16.4392 14.3434 16.9223 14.1074 17.2943 13.7387C17.5169 13.518 17.6938 13.2555 17.8149 12.9663C17.936 12.6771 17.9988 12.3669 18 12.0534C18.0011 11.7399 17.9404 11.4293 17.8213 11.1393C17.7023 10.8493 17.5273 10.5855 17.3063 10.3632L13.728 6.78491C13.5064 6.56311 13.2433 6.38716 12.9537 6.26711C12.6641 6.14706 12.3537 6.08527 12.0402 6.08527C11.7267 6.08527 11.4163 6.14706 11.1267 6.26711C10.8371 6.38716 10.574 6.56311 10.3525 6.78491L6.77416 10.3632C6.37455 10.774 6.1362 11.315 6.10271 11.8871C6.06922 12.4593 6.24283 13.0243 6.59177 13.479C6.94071 13.9336 7.44167 14.2474 8.00301 14.363C8.56435 14.4786 9.14854 14.3883 9.64873 14.1085V15.7783C9.64873 16.411 9.90006 17.0178 10.3474 17.4652C10.7948 17.9125 11.4016 18.1639 12.0343 18.1639C12.6669 18.1639 13.2737 17.9125 13.7211 17.4652C14.1685 17.0178 14.4198 16.411 14.4198 15.7783V14.1085C14.8731 14.371 15.4001 14.477 15.9196 14.4102Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function UploadMenuIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.785 8.74109C21.2027 9.31975 23 11.4951 23 14.0902C23 16.9143 20.8715 19.2771 18.1311 19.5902H17.5L6.59016 19.5894C6.56016 19.5899 6.53011 19.5902 6.5 19.5902C3.46243 19.5902 1 17.1277 1 14.0902C1 11.3599 2.98933 9.09437 5.59757 8.66384C6.42452 5.80871 9.05867 3.72131 12.1803 3.72131C15.3301 3.72131 17.9835 5.84644 18.785 8.74109ZM7.26481 15.0787L11.764 6.11977C11.8761 5.89665 12.1957 5.90005 12.303 6.12552L16.5558 15.0643C16.6849 15.3356 16.3793 15.6071 16.1251 15.447L12.195 12.9725C12.0995 12.9124 11.9784 12.911 11.8815 12.9688L7.68659 15.471C7.42894 15.6247 7.13017 15.3468 7.26481 15.0787ZM11.8893 14.0597C11.9864 14.0019 12.1078 14.0037 12.2032 14.0642L16.4258 16.7412C16.5654 16.8298 16.6071 17.0145 16.519 17.1544L16.2025 17.6572C16.114 17.7977 15.9281 17.8396 15.7879 17.7506L12.1864 15.4649C12.0909 15.4043 11.9695 15.4025 11.8724 15.4603L7.97919 17.774C7.83692 17.8585 7.65306 17.8119 7.56828 17.6698L7.26384 17.1594C7.17887 17.0169 7.22561 16.8326 7.36816 16.7478L11.8893 14.0597Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function HomeIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g width="20" height="20">
        <path
          d="M4 15.25V8.25C4 8.01599 4.05208 7.79428 4.15625 7.5849C4.26042 7.37552 4.40972 7.19444 4.60417 7.04167L9.10417 3.66667C9.38194 3.47222 9.68056 3.375 10 3.375C10.3194 3.375 10.6181 3.47222 10.8958 3.66667L15.3958 7.04167C15.5903 7.19444 15.7396 7.37552 15.8438 7.5849C15.9479 7.79428 16 8.01599 16 8.25V15.25C16 15.7312 15.8286 16.1432 15.4859 16.4859C15.1432 16.8286 14.7312 17 14.25 17H12.25C12.0375 17 11.8594 16.9281 11.7156 16.7844C11.5719 16.6406 11.5 16.4625 11.5 16.25V12.25C11.5 12.0375 11.4283 11.8594 11.2849 11.7156C11.1415 11.5719 10.9638 11.5 10.7518 11.5H9.25548C9.04349 11.5 8.86458 11.5719 8.71875 11.7156C8.57292 11.8594 8.5 12.0375 8.5 12.25V16.25C8.5 16.4625 8.42813 16.6406 8.28438 16.7844C8.14062 16.9281 7.9625 17 7.75 17H5.75C5.26875 17 4.85677 16.8286 4.51406 16.4859C4.17135 16.1432 4 15.7312 4 15.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
